var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeyondBlockchainsS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 119,
    viewBox: "0 0 143 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 119,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.346 35.749V87.3574L72 113.234L21.6543 87.3574V35.749L72 9.87207L122.346 35.749Z",
    fill: "#EFE4D2",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7358 49.7896V73.2974L72.1138 85.1147L49.4927 73.2974V49.7896L72.1138 37.9731L94.7358 49.7896Z",
    fill: "#FD4C00",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1145 54.5835C75.9585 54.5837 79.0745 57.7004 79.0745 61.5444C79.0743 65.3883 75.9584 68.5042 72.1145 68.5044C68.2704 68.5044 65.1538 65.3885 65.1536 61.5444C65.1536 57.7002 68.2703 54.5835 72.1145 54.5835Z",
    fill: "#EFE4D2",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8883 5.75C74.434 5.75 76.4985 7.81366 76.4987 10.3594C76.4987 12.9052 74.4341 14.9697 71.8883 14.9697C69.3426 14.9696 67.2789 12.9051 67.2789 10.3594C67.2791 7.81375 69.3427 5.75014 71.8883 5.75Z",
    fill: "#FD4C00",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3076 81.8582C23.8534 81.8582 25.9178 83.9218 25.918 86.4675C25.918 89.0134 23.8534 91.0779 21.3076 91.0779C18.7619 91.0777 16.6982 89.0133 16.6982 86.4675C16.6984 83.9219 18.762 81.8583 21.3076 81.8582Z",
    fill: "#FD4C00",
    stroke: "black",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.126 81.8582C125.672 81.8582 127.736 83.9218 127.737 86.4675C127.737 89.0134 125.672 91.0779 123.126 91.0779C120.581 91.0777 118.517 89.0133 118.517 86.4675C118.517 83.9219 120.581 81.8583 123.126 81.8582Z",
    fill: "#FD4C00",
    stroke: "black",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9994 15.6486C71.9994 19.6948 71.9994 21.9633 71.9994 26.0095",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8859 97.0981C71.9751 103.288 72.0251 106.758 72.1143 112.948",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6552 45.1188L21.9956 35.8443",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6558 76.8179L25.5482 83.7854",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.233 35.8419L106.25 45.1168",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.358 83.7853L106.25 76.8178",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondBlockchainsS);
export default __webpack_public_path__ + "static/media/beyond-blockchains-s.4bcfe93c79a7976d0cae9ce7987f38b3.svg";
export { ForwardRef as ReactComponent };